// extracted by mini-css-extract-plugin
export default {"header":"HYQq3 ZdH1P","withShadow":"BJYCp","col":"hp3eT","logotype":"D0l6a","logotypeRu":"yNKq_","iconSearch":"qfWmT","burger":"o8iFO","phone":"K3Ocr","callbackArrow":"lV8Il"};